import { Type } from "../utils/type";
import { formatCPABeforeSend } from "../../utils/helper";

export const RevenueTier = Type("RevenueTier", {
  id: Number,
  remoteId: Number,
  name: String,
  share: String,
  instagram_share: String,
  default: Boolean,
  validates_users: Boolean,
});

export const serializeRevenueTier = tier => ({
  id: tier.remoteId === -1 ? null : tier.remoteId,
  name: tier.name,
  revenue_share: formatCPABeforeSend(tier.share),
  instagram_revenue_share: formatCPABeforeSend(tier.instagram_share),
  default: tier.default,
  validates_users: tier.validates_users,
});
